<template>
  <div style="background: #F2F6FC;">
    <MyBanner />
    <MyRight />
    <div>
      <div class="w1200">
        <div class="title">
          <div class="AnnouncementDetails">
            <el-breadcrumb :separator-icon="ArrowRight">
              <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item @click="goerji"><span class="title-name">{{name}}</span></el-breadcrumb-item>
              <el-breadcrumb-item>内容详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="content">
          <div class="content-tip">
            <div class="bt">{{mesageData.title}}</div>
            <div class="announcement-flex">
              <div class="flex">
                <div class="title-box">发布时间：</div>
                <div class="content-box">{{mesageData.updateTime}}</div>
              </div>
            </div>
          </div>
          <div class="content-message" v-html="mesageData.content" v-if="mesageData.content != ''"></div>
          <div class="content-message" style="text-align: center;line-height: 100px;color: gray;" v-else>暂无详情</div>

          <div style="padding: 0 20px;" v-if="mesageData.attachList&&mesageData.attachList.length > 0">
            <div style="font-size: 14px;color: rgb(10, 96, 234);text-align: left;margin: 10px 0;">附件：</div>
            <div v-for="item in mesageData.attachList" :key="item.id" style="padding: 10px 0;cursor: pointer;" @click="upload(item.name)">{{item.originalName}}</div>
          </div>
        </div>
      </div>
      <MyFooter />
    </div>
  </div>
</template>
<script setup>
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import MyRight from "@/components/RightFixd.vue";
import { ArrowRight } from '@element-plus/icons-vue'
import { getArticleDetailsById } from '@/api/index.js'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
let router = useRouter();
let number = ref(0)
let name = ref('')
let mesageData = ref({})
let goerji = () => {
  if (number.value == 3) {
    router.push({ path: '/helpCenter' })
  } else if (number.value == 2) {
    router.push({ path: '/platformDynamics', query: { title: name.value } })
  }
  // router.push({ path: '/platformDynamics', query: { title: name.value } })
  // router.push({ path: '/proceDure' })
}
let upload = (url) => {
  const currentUrl = window.location.href;
  const parts = currentUrl.split('/');
  const baseUrl = `${parts[0]}//${parts[2]}`;
  window.open(`${baseUrl}` + '/' + `${url}`)
}
onMounted(async () => {
  number.value = router.currentRoute.value.query.type
  name.value = router.currentRoute.value.query.title
  await getArticleDetailsById({ id: router.currentRoute.value.query.ids }).then(res => {
    mesageData.value = res.data
  })
})

</script>
<style scoped>
a {
  text-decoration: none;
}
::v-deep .el-tabs__item {
  font-size: 18px;
  color: rgba(0, 117, 194, 1);
}
::v-deep .el-tabs__active-bar {
  background-color: rgba(0, 117, 194, 1);
}
::v-deep .el-table th.el-table__cell {
  background: rgba(243, 245, 247, 1);
  font-size: 14px;
  font-weight: 400;
  color: rgb(79, 84, 112);
}
.w1200 {
  width: 1300px;
  margin: 0 auto;
}
.content-message {
  min-height: 100px;
  border-radius: 5px;
  /* background: rgb(255, 255, 255); */
  /* border: 1px solid rgb(215, 215, 215); */
  color: #344;
  padding: 0 20px;
  box-sizing: border-box;
  line-height: 1.8;
  font-size: 16px;
}
.bt {
  font-size: 24px;
  font-weight: 600;
  color: #444;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e0e0;
  text-align: center;
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0 15px 0;
}
.AnnouncementDetails {
  font-size: 22px;
  color: rgb(0, 0, 0);
  display: flex;
  align-items: flex-end;
}
.line1 {
  width: 4px;
  height: 28px;
  background: rgb(10, 96, 234);
  margin-right: 5px;
}
.line2 {
  width: 4px;
  height: 18px;
  background: rgb(10, 96, 234);
  margin-right: 5px;
}
.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  margin-bottom: 20px;
}
.content-tip {
  border-radius: 5px;
  padding: 20px;
}
.title-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}
.content-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}
.flex {
  display: flex;
  align-items: center;
}
.announcement-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.title-name:hover {
  color: #409eff;
}
.title-name {
  color: #303133;
  font-weight: 600;
  cursor: pointer;
}
</style>